import "esbuild-css-modules-plugin-ns-css:components/twin.module.css";

import { inject } from "esbuild-css-modules-plugin-ns-js:components/twin.module.css:injector.js";
export default new Proxy({
  "assistantAvatar": "twin-module__assistantAvatar_ZfqEGG__010",
  "assistantBubble": "twin-module__assistantBubble_ZfqEGG__010",
  "assistantFallback": "twin-module__assistantFallback_ZfqEGG__010",
  "assistantFallbackShell": "twin-module__assistantFallbackShell_ZfqEGG__010",
  "closeConfirmActions": "twin-module__closeConfirmActions_ZfqEGG__010",
  "closeConfirmButton": "twin-module__closeConfirmButton_ZfqEGG__010",
  "closeConfirmCancel": "twin-module__closeConfirmCancel_ZfqEGG__010",
  "closeConfirmDialog": "twin-module__closeConfirmDialog_ZfqEGG__010",
  "closeConfirmIcon": "twin-module__closeConfirmIcon_ZfqEGG__010",
  "closeConfirmIconShell": "twin-module__closeConfirmIconShell_ZfqEGG__010",
  "closeConfirmOverlay": "twin-module__closeConfirmOverlay_ZfqEGG__010",
  "closeConfirmTitle": "twin-module__closeConfirmTitle_ZfqEGG__010",
  "container": "twin-module__container_ZfqEGG__010",
  "emptyAvatar": "twin-module__emptyAvatar_ZfqEGG__010",
  "emptyIcon": "twin-module__emptyIcon_ZfqEGG__010",
  "emptyState": "twin-module__emptyState_ZfqEGG__010",
  "emptySubtitle": "twin-module__emptySubtitle_ZfqEGG__010",
  "emptyTitle": "twin-module__emptyTitle_ZfqEGG__010",
  "header": "twin-module__header_ZfqEGG__010",
  "headerActionButton": "twin-module__headerActionButton_ZfqEGG__010",
  "headerActionIcon": "twin-module__headerActionIcon_ZfqEGG__010",
  "headerActions": "twin-module__headerActions_ZfqEGG__010",
  "headerBrand": "twin-module__headerBrand_ZfqEGG__010",
  "headerCloseButton": "twin-module__headerCloseButton_ZfqEGG__010",
  "headerIcon": "twin-module__headerIcon_ZfqEGG__010",
  "headerLeft": "twin-module__headerLeft_ZfqEGG__010",
  "headerLogo": "twin-module__headerLogo_ZfqEGG__010",
  "headerLogoShell": "twin-module__headerLogoShell_ZfqEGG__010",
  "headerSubtitle": "twin-module__headerSubtitle_ZfqEGG__010",
  "headerTitle": "twin-module__headerTitle_ZfqEGG__010",
  "input": "twin-module__input_ZfqEGG__010",
  "inputArea": "twin-module__inputArea_ZfqEGG__010",
  "inputRow": "twin-module__inputRow_ZfqEGG__010",
  "messageAvatarShell": "twin-module__messageAvatarShell_ZfqEGG__010",
  "messageBubble": "twin-module__messageBubble_ZfqEGG__010",
  "messageRow": "twin-module__messageRow_ZfqEGG__010",
  "messageRowUser": "twin-module__messageRowUser_ZfqEGG__010",
  "messages": "twin-module__messages_ZfqEGG__010",
  "sendButton": "twin-module__sendButton_ZfqEGG__010",
  "sendIcon": "twin-module__sendIcon_ZfqEGG__010",
  "timestamp": "twin-module__timestamp_ZfqEGG__010",
  "timestampUser": "twin-module__timestampUser_ZfqEGG__010",
  "twin": "twin-module__twin_ZfqEGG__010",
  "typingBubble": "twin-module__typingBubble_ZfqEGG__010",
  "typingDot": "twin-module__typingDot_ZfqEGG__010",
  "typingDots": "twin-module__typingDots_ZfqEGG__010",
  "userAvatar": "twin-module__userAvatar_ZfqEGG__010",
  "userBubble": "twin-module__userBubble_ZfqEGG__010",
  "userIcon": "twin-module__userIcon_ZfqEGG__010"
}, {
  get: function(source, key) {
    inject();
    return source[key];
  }
});
      